import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* eslint-disable jsx-a11y/no-static-element-interactions */
import "./scss/index.scss";
import * as React from "react";
import { useIntl } from "react-intl";
import ReactSVG from "react-svg";
import passwordResetIcon from "../../images/remember-password.svg";
import { Button, Form, OverlayContext, OverlayTheme, OverlayType, TextField } from "..";
import { passwordResetUrl } from "../../app/routes";
import { maybe } from "../../core/utils";
import { TypedPasswordResetMutation } from "./queries";
import { commonMessages } from "../../intl";

var PasswordResetForm = function PasswordResetForm(_ref) {
  var onSuccess = _ref.onSuccess;
  var intl = useIntl();
  return React.createElement("div", {
    className: "password-reset-form"
  }, React.createElement(ReactSVG, {
    path: passwordResetIcon,
    className: "password-reset-form__title__reset-icon"
  }), React.createElement("h4", {
    className: "password-reset-form__title"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Can’t remember your password?",
    "id": "components.PasswordResetForm.index.1651418227"
  }, "id", "components.PasswordResetForm.index.1651418227"))), React.createElement("p", {
    className: "password-reset-form__text"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Please provide us your email address so we can share you a link to reset your password",
    "id": "components.PasswordResetForm.index.805890313"
  }, "id", "components.PasswordResetForm.index.805890313"))), React.createElement(TypedPasswordResetMutation, null, function (passwordReset, _ref2) {
    var loading = _ref2.loading,
        data = _ref2.data;
    return React.createElement(Form, {
      className: "password-reset-form__form",
      errors: maybe(function () {
        return data.requestPasswordReset.errors;
      }, []),
      onSubmit:
      /*#__PURE__*/
      function () {
        var _ref4 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(event, _ref3) {
          var _response$data$reques;

          var email, response, hasErrors;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  email = _ref3.email;
                  event.preventDefault();
                  _context.next = 4;
                  return passwordReset({
                    variables: {
                      email: email,
                      redirectUrl: "".concat(window.location.origin).concat(passwordResetUrl)
                    }
                  });

                case 4:
                  response = _context.sent;
                  hasErrors = response && !!((_response$data$reques = response.data.requestPasswordReset.errors) === null || _response$data$reques === void 0 ? void 0 : _response$data$reques.length);

                  if (!hasErrors && onSuccess) {
                    // NOTE: for Denis: mock success case here
                    onSuccess();
                  }

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref4.apply(this, arguments);
        };
      }()
    }, React.createElement(TextField, {
      name: "email",
      autoComplete: "email",
      label: intl.formatMessage(commonMessages.shortEmail),
      type: "email",
      required: true
    }), React.createElement("div", {
      className: "password-reset-form__button"
    }, React.createElement(Button, _extends({
      className: "red",
      type: "submit"
    }, loading && {
      disabled: true
    }), loading ? intl.formatMessage(commonMessages.loading) : intl.formatMessage(commonMessages.send))));
  }), React.createElement(OverlayContext.Consumer, null, function (overlay) {
    return React.createElement("span", {
      className: "u-link",
      onClick: function onClick() {
        return overlay.show(OverlayType.login, OverlayTheme.modal);
      }
    }, intl.formatMessage(_defineProperty({
      defaultMessage: "Back to Sign In",
      "id": "components.PasswordResetForm.index.2900133796"
    }, "id", "components.PasswordResetForm.index.2900133796")));
  }));
};

export default PasswordResetForm;